import React, { useContext } from "react";
import { LocalizationContext } from "src/lib/context";
import { HomeTitleSection } from "../CommonComponents/HomeTitleSection";
import { JobCard } from "../JobCard";
import ScrollXLayout from "../ScrollXLayout";
import { capitalize } from "lodash";

type Props = {
  type: string;
  jobs: any[];
  title?: string;
};

const CategorizedJobList = ({ type, jobs, title }: Props) => {
  const { jobPage, uiGeneral, jobsPage } =
    useContext(LocalizationContext).localeStrings;
  const offerDeadlineText = jobPage.offerDeadline;

  const jobTypeIds = [
    "agricultural",
    "survey and mapping",
    "creative",
    "other",
  ];
  const localizedJobTypes = uiGeneral.skills.filter((s) =>
    jobTypeIds.includes(s.skillId)
  );
  const localizedType = localizedJobTypes.filter((t) => t.skillId === type)[0]
    ?.name;

  return (
    <div>
      <HomeTitleSection
        link="#all-jobs"
        title={title ? title : capitalize(localizedType)}
        subtitle={jobsPage.sectionSubtitle}
        itemQuantity={jobs.filter((job) => job.projectType === type).length}
      />
      <ScrollXLayout className="mt-large">
        {jobs
          .filter((job) => job.projectType === type)
          .map((job: any) => (
            <JobCard
              job={job}
              offerDeadlineText={offerDeadlineText}
              key={job.id}
              dronerTenders={undefined}
            />
          ))}
      </ScrollXLayout>
    </div>
  );
};

export default CategorizedJobList;
